export default __webpack_public_path__ + "static/Aeonik-Black-0fd2dffebe8f76891fc28ac70819d566.otf";